import * as React from 'react';
import { colors } from '../../../ui/theme';
import CheckIcon from '../../../../components/icons/CheckIcon';

export default function WhyMinglChecklist({ text }: { text: string }) {
  return (
    <div className="pb4 flex items-center">
      <div
        className="dib"
        style={{
          minWidth: `20px`,
          minHeight: `20px`,
          maxWidth: `20px`,
          maxHeight: `20px`,
        }}
      >
        <CheckIcon color={colors.green400} size={20} />
      </div>
      <span className="pl3 f4 mingl-gray">{text}</span>
    </div>
  );
}
